import {
  EGroupsViewActions,
  GroupsViewActions,
} from '@myStore/groups-view/groups-view.actions';
import {
  IGroupsViewState,
  initialGroupsViewState,
} from '@myStore/groups-view/groups-view.state';

export const groupsViewReducers = (
  state = initialGroupsViewState,
  actions: GroupsViewActions
): IGroupsViewState => {
  switch (actions.type) {
    case EGroupsViewActions.GetGroupDetailRequest:
      return {
        ...state,
        group: {
          ...state.group,
          isLoading: true,
        },
      };
    case EGroupsViewActions.GetGroupDetailSuccess:
      return {
        ...state,
        group: {
          ...state.group,
          detail: actions.payload,
          isLoading: false,
        },
      };
    case EGroupsViewActions.GetGroupDetailFailure:
      return {
        ...state,
        group: {
          ...state.group,
          isLoading: false,
          errors: actions.errors,
        },
      };
    case EGroupsViewActions.ClearGroupDetail:
      return {
        ...state,
        group: {
          ...state.group,
          detail: null,
        },
      };
    case EGroupsViewActions.GetGroupsRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EGroupsViewActions.GetGroupsSuccess:
      return {
        ...state,
        groups: actions.groups,
        isLoading: false,
      };
    case EGroupsViewActions.GetGroupsFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
      };
    case EGroupsViewActions.ClearGroups:
      return {
        ...state,
        errors: {},
        groups: null,
      };
    case EGroupsViewActions.GetActiveCourseGroupsRequest:
      return {
        ...state,
        courseGroups: {
          ...state.courseGroups,
          isLoading: true,
        },
      };
    case EGroupsViewActions.GetActiveCourseGroupsSuccess:
      return {
        ...state,
        courseGroups: {
          ...state.courseGroups,
          isLoading: false,
          data: actions.groups,
        },
      };
    case EGroupsViewActions.GetActiveCourseGroupsFailure:
      return {
        ...state,
        courseGroups: {
          ...state.courseGroups,
          isLoading: false,
          errors: actions.error,
        },
      };
    case EGroupsViewActions.GetAllCourseGroupsRequest:
      return {
        ...state,
        courseGroups: {
          ...state.courseGroups,
          isLoading: true,
        },
      };
    case EGroupsViewActions.GetAllCourseGroupsSuccess:
      return {
        ...state,
        courseGroups: {
          ...state.courseGroups,
          isLoading: false,
          data: actions.groups,
        },
      };
    case EGroupsViewActions.GetAllCourseGroupsFailure:
      return {
        ...state,
        courseGroups: {
          ...state.courseGroups,
          isLoading: false,
          errors: actions.error,
        },
      };
    case EGroupsViewActions.GetInactiveCourseGroupsRequest:
      return {
        ...state,
        courseGroups: {
          ...state.courseGroups,
          isLoading: true,
        },
      };
    case EGroupsViewActions.GetInactiveCourseGroupsSuccess:
      return {
        ...state,
        courseGroups: {
          ...state.courseGroups,
          isLoading: false,
          data: actions.groups,
        },
      };
    case EGroupsViewActions.GetInactiveCourseGroupsFailure:
      return {
        ...state,
        courseGroups: {
          ...state.courseGroups,
          isLoading: false,
          errors: actions.error,
        },
      };
    case EGroupsViewActions.ClearCourseGroups:
      return {
        ...state,
        courseGroups: {
          ...state.courseGroups,
          data: null,
          errors: null,
        },
      };

    case EGroupsViewActions.GetStudentsTransfersGroupsRequest:
      return {
        ...state,
        studentsTransfersGroups: {
          ...state.studentsTransfersGroups,
          isLoading: true,
        },
      };
    case EGroupsViewActions.GetStudentsTransfersGroupsSuccess:
      return {
        ...state,
        studentsTransfersGroups: {
          ...state.studentsTransfersGroups,
          data: actions.groups,
          isLoading: false,
        },
      };
    case EGroupsViewActions.GetStudentsTransfersGroupsFailure:
      return {
        ...state,
        studentsTransfersGroups: {
          ...state.studentsTransfersGroups,
          errors: actions.error,
          isLoading: false,
        },
      };
    case EGroupsViewActions.ClearStudentsTransfersGroups:
      return {
        ...state,
        studentsTransfersGroups: {
          ...state.studentsTransfersGroups,
          data: null,
          errors: null,
        },
      };
    case EGroupsViewActions.GetStudentAccessRequest:
      return {
        ...state,
        userAccess: {
          ...state.userAccess,
          isLoading: true,
        },
      };
    case EGroupsViewActions.GetStudentAccessSuccess:
      return {
        ...state,
        userAccess: {
          ...state.userAccess,
          data: actions.payload,
          isLoading: false,
        },
      };
    case EGroupsViewActions.GetStudentAccessFailure:
      return {
        ...state,
        userAccess: {
          ...state.userAccess,
          isLoading: false,
          errors: actions.errors,
        },
      };
    case EGroupsViewActions.ClearGetStudentAccess:
      return {
        ...state,
        userAccess: {
          ...state.userAccess,
          data: null,
          isLoading: false,
          errors: null,
        },
      };

    default:
      return state;
  }
};
